import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import fetchDux from '../../state/fetch-dux';
import Layout from '../ui/Layout';
import MetaTags from 'react-meta-tags';
import queryString from 'query-string';
import Loading from '../ui/Loading';
import { Link } from 'react-router-dom';
import MetaLoader from '../ui/MetaLoader';

class VerifyAccountRoute extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    const {
      history,
      postVerifyAccount,
      location: { search }
    } = this.props;

    const { r } = queryString.parse(search || '');
    if (!r) return history.push('/');

    postVerifyAccount({ token: r });

    document.body.classList.add(
      'page-template',
      'page-template-page-templates',
      'page-template-shop-login',
      'page-template-page-templatesshop-login-php',
      'page',
      'page-id-240',
      'page-child',
      'parent-pageid-212',
      'no-sidebar'
    );
  }
  componentWillUnmount() {
    document.body.classList.remove(
      'page-template',
      'page-template-page-templates',
      'page-template-shop-login',
      'page-template-page-templatesshop-login-php',
      'page',
      'page-id-240',
      'page-child',
      'parent-pageid-212',
      'no-sidebar'
    );
  }
  render() {
    const scrollToTop = () => window.scrollTo(0, 0);

    const {
      inProgress,
      error,
      result
    } = this.props;

    return (
      <Layout>
        <MetaLoader title="Verify Account | Twomey" />
        <MetaTags>
          <title>Verify Account | Twomey</title>
          <meta property="og:site_name" content="Twomey.com" />
          <meta property="og:title" content="Verify Account | Twomey" />
          <meta property="og:type" content="article" />
          <meta property="og:url" content="https://twomey.com/account/verify" />
        </MetaTags>
        <div id="content" className="site-content">
          <div id="primary" className="content-area">
            <main
              id="main"
              className="site-main shop-page nohero extra cart-page"
            >
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-md-10">
                    <div className="row">
                      <div className="col-md-12">
                        <h1 className="shop-large text-center">
                          Verify Account
                        </h1>
                        <br />
                      </div>
                      <div className="col-md-12">
                        <div>
                          {inProgress && <Loading fullPage scrollToTop />}
                          {!inProgress &&
                            error &&
                            <div
                              style={{ color: '#dc3545', textAlign: 'center' }}
                            >
                              Unable to validate account
                            </div>}
                          {!inProgress &&
                            result &&
                            <div style={{ textAlign: 'center' }}>
                              Account has been validated!
                              <br />
                              Please <Link to="/account/login/">Login</Link>
                            </div>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </main>
          </div>
          <div className="container text-right">
            <a href="#top" className="back-to-top" onClick={scrollToTop}>
              Back to top
            </a>
          </div>
        </div>
      </Layout>
    );
  }
}

const mapState = state => {
  const {
    inProgress,
    error,
    result
  } = state.postVerifyAccount.toJS();

  return {
    inProgress,
    error,
    result
  };
};

const mapDispatch = dispatch =>
  bindActionCreators(
    {
      postVerifyAccount: fetchDux.postVerifyAccount.createAction
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(VerifyAccountRoute);
